import { jsxs as s, jsx as t } from "react/jsx-runtime";
import { useState as g, useRef as k, useEffect as fe } from "react";
import { u as f } from "./index-6a632112.mjs";
import { S as p } from "./types-b577bf77.mjs";
import { S as pe } from "./pause-316ed38b.mjs";
import { S as ge } from "./playFilled-b880efda.mjs";
import { s as c, r as y, d as be, e as xe, a as we, Q as U } from "./themes-5f0b3c3d.mjs";
import { l as ye } from "./lineHeights-72d3110c.mjs";
function Ce({
  title: e,
  titleId: a,
  size: r,
  height: h,
  width: m,
  ...v
}) {
  const i = r ? p[r] : p.s;
  return /* @__PURE__ */ s(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 72 72",
      height: r ? i : h || i,
      width: r ? i : m || i,
      "aria-labelledby": a,
      ...v,
      children: [
        e ? /* @__PURE__ */ t("title", { id: a, children: e }) : null,
        /* @__PURE__ */ t("g", { clipPath: "url(#Expand_svg__a)", children: /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M47.34 14.58 61.2 10.8l-3.78 13.86-3.78-3.78L42.12 32.4l-2.52-2.52 11.52-11.52-3.78-3.78Zm10.08 32.76L61.2 61.2l-13.86-3.78 3.78-3.78L39.6 42.12l2.52-2.52 11.52 11.52 3.78-3.78ZM32.4 42.12l-2.52-2.52-11.52 11.52-3.78-3.78L10.8 61.2l13.86-3.78-3.78-3.78L32.4 42.12ZM20.88 18.36 32.4 29.88l-2.52 2.52-11.52-11.52-3.78 3.78L10.8 10.8l13.86 3.78-3.78 3.78Z",
            clipRule: "evenodd"
          }
        ) }),
        /* @__PURE__ */ t("defs", { children: /* @__PURE__ */ t("clipPath", { id: "Expand_svg__a", children: /* @__PURE__ */ t("path", { fill: "currentColor", d: "M0 0h72v72H0z" }) }) })
      ]
    }
  );
}
function $e({
  title: e,
  titleId: a,
  size: r,
  height: h,
  width: m,
  ...v
}) {
  const i = r ? p[r] : p.s;
  return /* @__PURE__ */ s(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 72 72",
      height: r ? i : h || i,
      width: r ? i : m || i,
      "aria-labelledby": a,
      ...v,
      children: [
        e ? /* @__PURE__ */ t("title", { id: a, children: e }) : null,
        /* @__PURE__ */ t("g", { clipPath: "url(#Mute_svg__a)", children: /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M20.34 47.52C18.54 44.46 18 40.14 18 36s.72-8.28 1.98-10.8h8.82v14.04l3.6-3.6V23.58l14.4-9.18v6.84l3.6-3.6v-9.9L28.8 21.6H18s-3.6 4.68-3.6 14.4c0 8.46 2.7 13.14 3.42 14.22l2.52-2.7ZM46.8 36.36V57.6l-12.96-8.28-2.52 2.7L50.4 64.26v-31.5l-3.6 3.6Zm15.437-25.543-51.42 51.42 2.545 2.546 51.42-51.42-2.545-2.546Z",
            clipRule: "evenodd"
          }
        ) }),
        /* @__PURE__ */ t("defs", { children: /* @__PURE__ */ t("clipPath", { id: "Mute_svg__a", children: /* @__PURE__ */ t("path", { fill: "currentColor", d: "M0 0h72v72H0z" }) }) })
      ]
    }
  );
}
function Pe({
  title: e,
  titleId: a,
  size: r,
  height: h,
  width: m,
  ...v
}) {
  const i = r ? p[r] : p.s;
  return /* @__PURE__ */ s(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 72 72",
      height: r ? i : h || i,
      width: r ? i : m || i,
      "aria-labelledby": a,
      ...v,
      children: [
        e ? /* @__PURE__ */ t("title", { id: a, children: e }) : null,
        /* @__PURE__ */ t("g", { clipPath: "url(#Share__Android_svg__a)", children: /* @__PURE__ */ t("g", { clipPath: "url(#Share__Android_svg__b)", children: /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M59.66.075c6.645 0 12.033 5.388 12.033 12.034 0 6.646-5.388 12.034-12.034 12.034a12.014 12.014 0 0 1-9.528-4.682L23.943 32.555c.325 1.091.5 2.248.5 3.445 0 1.197-.175 2.354-.5 3.445L50.169 52.56a12.014 12.014 0 0 1 9.49-4.634c6.646 0 12.034 5.388 12.034 12.034 0 6.646-5.388 12.034-12.034 12.034-6.646 0-12.034-5.388-12.034-12.034 0-.912.102-1.8.294-2.655L21.372 44.031a12.004 12.004 0 0 1-8.963 4.003C5.763 48.034.375 42.646.375 36c0-6.646 5.388-12.034 12.034-12.034 3.56 0 6.76 1.546 8.963 4.003l26.533-13.267a12.076 12.076 0 0 1-.28-2.593c0-6.646 5.388-12.034 12.034-12.034Zm0 53.1a6.784 6.784 0 1 0-.001 13.568 6.784 6.784 0 0 0 0-13.568Zm-47.25-23.96a6.784 6.784 0 1 0-.001 13.569 6.784 6.784 0 0 0 0-13.568Zm47.25-23.89a6.784 6.784 0 1 0-.001 13.568 6.784 6.784 0 0 0 0-13.568Z",
            clipRule: "evenodd"
          }
        ) }) }),
        /* @__PURE__ */ s("defs", { children: [
          /* @__PURE__ */ t("clipPath", { id: "Share__Android_svg__a", children: /* @__PURE__ */ t("path", { fill: "currentColor", d: "M0 0h72v72H0z" }) }),
          /* @__PURE__ */ t("clipPath", { id: "Share__Android_svg__b", children: /* @__PURE__ */ t("path", { fill: "currentColor", d: "M0 0h72v72H0z" }) })
        ] })
      ]
    }
  );
}
function Se({
  title: e,
  titleId: a,
  size: r,
  height: h,
  width: m,
  ...v
}) {
  const i = r ? p[r] : p.s;
  return /* @__PURE__ */ s(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 72 72",
      height: r ? i : h || i,
      width: r ? i : m || i,
      "aria-labelledby": a,
      ...v,
      children: [
        e ? /* @__PURE__ */ t("title", { id: a, children: e }) : null,
        /* @__PURE__ */ t("g", { clipPath: "url(#Volume_svg__a)", children: /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M7.2 21.6H18L39.6 7.2v57.6L18 50.4H7.2c-2.52-3.06-3.6-9-3.6-14.4s1.08-10.98 3.6-14.4Zm11.88 25.2L36 58.14V13.86L21.6 23.4V36c0 1.98-1.62 3.6-3.6 3.6V25.2H9.18C7.92 27.72 7.2 31.86 7.2 36c0 4.14.72 8.28 1.98 10.8h9.9Zm38.34-31.32-2.88 2.34C58.68 22.68 61.2 29.16 61.2 36s-2.52 13.32-6.48 18.18l2.88 2.34c4.5-5.58 7.2-12.78 7.2-20.52s-2.7-14.94-7.38-20.52Zm-8.46 6.84 2.88-2.34c3.6 4.32 5.76 9.9 5.94 16.02 0 6.12-2.16 11.7-5.76 16.02l-2.88-2.34C52.2 45.9 54 41.22 54 36c0-5.22-1.8-9.9-5.04-13.68Zm-2.7 25.02c2.7-3.06 4.14-7.02 4.14-11.34s-1.44-8.28-4.14-11.7l-2.88 2.34c1.98 2.52 3.24 5.58 3.24 9.18 0 3.6-1.26 6.66-3.24 9.18l2.88 2.34Z",
            clipRule: "evenodd"
          }
        ) }),
        /* @__PURE__ */ t("defs", { children: /* @__PURE__ */ t("clipPath", { id: "Volume_svg__a", children: /* @__PURE__ */ t("path", { fill: "currentColor", d: "M0 0h72v72H0z" }) }) })
      ]
    }
  );
}
function ke({
  title: e,
  titleId: a,
  size: r,
  height: h,
  width: m,
  ...v
}) {
  const i = r ? p[r] : p.s;
  return /* @__PURE__ */ s(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 23 16",
      height: r ? i : h || i,
      width: r ? i : m || i,
      "aria-labelledby": a,
      ...v,
      children: [
        e ? /* @__PURE__ */ t("title", { id: a, children: e }) : null,
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            d: "M11.177 7.181H9.85a1.653 1.653 0 0 0-.21-.579 1.557 1.557 0 0 0-.898-.7 2.023 2.023 0 0 0-.621-.092c-.396 0-.746.1-1.051.299-.306.196-.545.485-.718.866-.172.379-.259.842-.259 1.389 0 .556.087 1.025.26 1.406.175.379.414.665.717.86.305.191.654.287 1.047.287.218 0 .422-.028.611-.085.192-.06.363-.146.515-.26a1.582 1.582 0 0 0 .607-.987l1.328.007a2.86 2.86 0 0 1-.323.973c-.163.303-.377.57-.643.803-.265.23-.575.41-.93.54-.355.128-.75.191-1.183.191-.639 0-1.21-.148-1.711-.444A3.098 3.098 0 0 1 5.2 10.374c-.289-.56-.433-1.23-.433-2.01 0-.784.145-1.454.436-2.01a3.121 3.121 0 0 1 1.19-1.282 3.292 3.292 0 0 1 1.704-.444c.405 0 .782.057 1.13.17.348.114.658.28.93.501.272.218.496.485.671.803.178.314.294.674.348 1.08Zm7.432 0h-1.328a1.653 1.653 0 0 0-.21-.579 1.557 1.557 0 0 0-.898-.7 2.023 2.023 0 0 0-.622-.092c-.395 0-.745.1-1.05.299-.306.196-.545.485-.718.866-.173.379-.26.842-.26 1.389 0 .556.087 1.025.26 1.406.175.379.414.665.717.86.306.191.655.287 1.048.287.218 0 .421-.028.61-.085a1.67 1.67 0 0 0 .516-.26 1.584 1.584 0 0 0 .607-.987l1.328.007a2.86 2.86 0 0 1-.323.973c-.164.303-.378.57-.643.803-.265.23-.575.41-.93.54-.355.128-.75.191-1.183.191-.64 0-1.21-.148-1.711-.444a3.097 3.097 0 0 1-1.187-1.281c-.288-.56-.433-1.23-.433-2.01 0-.784.146-1.454.437-2.01a3.121 3.121 0 0 1 1.19-1.282 3.292 3.292 0 0 1 1.704-.444c.405 0 .781.057 1.13.17.347.114.657.28.93.501.272.218.496.485.671.803.178.314.294.674.348 1.08Z"
          }
        ),
        /* @__PURE__ */ t(
          "rect",
          {
            width: 20.5,
            height: 14.5,
            x: 1.417,
            y: 0.75,
            stroke: "currentColor",
            strokeWidth: 1.5,
            rx: 1.25
          }
        )
      ]
    }
  );
}
const _e = f.div`
  --thumbSize: ${c["3x"]};
  --volumeBarWidth: ${c["14x"]};

  display: flex;
  position: relative;
  max-width: fit-content;
  max-height: fit-content;

  // hide default full screen controls
  video::-webkit-media-controls {
    display: none !important;
  }

  &:hover {
    div {
      opacity: 1;
    }
  }
`, Be = f.video`
  max-width: 100%;
  max-height: 100%;
`, Te = f.div`
  opacity: 0;
  overflow: hidden;
  transition: opacity 0.35s ease-out;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: ${(e) => e.theme.components.videoPlayer.videoControlsBackgroundColor};
  color: ${(e) => e.theme.components.videoPlayer.videoControlsColor};
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${c["2x"]} ${c["5x"]} ${c["2x"]} ${c["5x"]};
  flex-direction: column;

  &:focus-within {
    opacity: 1;
  }
`, w = f.button`
  background-color: transparent;
  border: none;
  color: ${(e) => e.theme.components.videoPlayer.videoControlsColor};
  margin-right: ${c["5x"]};
  padding: 5px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:not(:disabled) {
    cursor: pointer;

    &:hover {
      background-color: ${(e) => e.theme.components.videoPlayer.buttonHoverColor};
      border-radius: ${y["2x"]};
    }

    &:focus-visible {
      outline: none;
      box-shadow: 0 0 0 2px
        ${(e) => e.theme.components.videoPlayer.focusColor};
      border-radius: ${y["2x"]};
    }
  }

  & > svg {
    width: ${c["5x"]};
    height: ${c["5x"]};
  }

  &:disabled {
    color: ${(e) => e.theme.components.videoPlayer.buttonDisabledColor};
  }
`, Me = f(w)`
  border-bottom: 2px solid transparent;
  padding: 5px 5px 3px 5px;

  &:not(:disabled) {
    ${(e) => e.$showSubtitles ? `
        border-bottom: 2px solid ${e.theme.components.videoPlayer.captionsEnabledColor};
        border-bottom-left-radius: initial !important;
        border-bottom-right-radius: initial !important;
      ` : ""}
  }
`, Ee = f.div`
  position: relative;
  width: 100%;
  height: ${c["1x"]};
  overflow: hidden;
  margin-bottom: ${c["2x"]};
  background: ${(e) => e.theme.components.videoPlayer.progressBarDefaultColor};
  border-radius: ${y["2x"]};
  cursor: pointer;

  &:focus-visible {
    outline: ${(e) => e.theme.components.videoPlayer.focusColor} solid
      2px;
    outline-offset: 3px;
  }

  & > div {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    border-radius: ${y["2x"]};
    width: 0;
    transition: width 0.1s ease-out;

    &:nth-of-type(1) {
      background: ${(e) => e.theme.components.videoPlayer.progressBarViewedColor};
      z-index: 1;
    }

    &:nth-of-type(2) {
      background: ${(e) => e.theme.components.videoPlayer.progressBarLoadedColor};
    }
  }
`, Ve = f.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
`, I = f.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`, Le = f.div`
  display: flex;
  align-items: center;
  font-family: ${be.body};
  font-style: normal;
  font-weight: ${xe.medium.XS.fontWeight};
  font-size: ${we.xxsmall};
  line-height: ${ye.xsmall};
  color: ${(e) => e.theme.components.videoPlayer.videoDurationTextColor};
`, Re = f.input`
  -webkit-appearance: none;
  max-width: 0;
  width: 0;
  height: 2px;
  transition: all 0.3s ease-out;
  background: ${(e) => e.theme.components.videoPlayer.volumeBarColor};
  cursor: pointer;
  margin-right: 0;

  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    border-radius: 6px;
    cursor: pointer;
    width: 0;
    height: 0;
    transition: all 0.3s ease-out;
    background: ${(e) => e.theme.components.videoPlayer.volumeBarThumbColor};
    border: none;
  }

  &::-moz-range-thumb {
    -webkit-appearance: none;
    border-radius: 6px;
    cursor: pointer;
    width: 0;
    height: 0;
    transition: all 0.3s ease-out;
    background: ${(e) => e.theme.components.videoPlayer.volumeBarThumbColor};
    border: none;
  }

  &:focus {
    outline: none;
  }

  @media ${U.tabletAndUp} and (hover: hover) {
    &:focus-visible {
      outline: ${(e) => e.theme.components.videoPlayer.focusColor} solid
        2px;
      outline-offset: 10px;
      width: var(--volumeBarWidth);
      max-width: var(--volumeBarWidth);
      margin-right: 18px;
      border-radius: ${y["2x"]};

      &::-webkit-slider-thumb {
        width: var(--thumbSize);
        height: var(--thumbSize);
      }

      &::-moz-range-thumb {
        width: var(--thumbSize);
        height: var(--thumbSize);
      }
    }
  }
`, Ze = f.div`
  display: flex;
  align-items: center;

  @media ${U.tabletAndUp} and (hover: hover) {
    &:hover {
      input[type='range'] {
        width: var(--volumeBarWidth);
        max-width: var(--volumeBarWidth);
        margin-right: 18px;

        &::-webkit-slider-thumb {
          width: var(--thumbSize);
          height: var(--thumbSize);
        }

        &::-moz-range-thumb {
          width: var(--thumbSize);
          height: var(--thumbSize);
        }
      }
    }
  }
`;
function Fe({
  src: e,
  isMuted: a = !1,
  shouldAutoPlay: r = !1,
  shouldLoop: h = !1,
  subtitlesOnByDefault: m = !1,
  children: v,
  onTimeUpdate: i,
  onEnded: O,
  onPlay: j,
  onPause: F,
  onLoadedMetadata: K,
  onProgress: Q,
  ...X
}) {
  const [E, _] = g(!1), [C, q] = g(m), [V, G] = g(!1), [J, L] = g(0), [B, $] = g(0), [T, R] = g(a ? 0 : 1), [Z, N] = g(1), [P, S] = g(-1), [Y, ee] = g("0:00"), u = k(null), H = k(null), A = k(null), z = k(null);
  function M() {
    const o = u?.current;
    E ? o.pause() : o.play();
  }
  function te() {
    _(!1), clearInterval(P), S(-1), O?.();
  }
  function oe() {
    const o = u?.current;
    if (ee(ue()), o.textTracks.length) {
      if (!C)
        for (let n = 0; n < o.textTracks.length; n++)
          o.textTracks[n].mode = "hidden";
      G(!0);
    }
    K?.();
  }
  function ne() {
    W(), Q?.();
  }
  function W() {
    const o = u?.current, n = o?.buffered, d = o.duration, l = o.currentTime;
    let b = 0, x = 0;
    try {
      for (; !(n.start(b) <= l && l <= n.end(b)); )
        b += 1;
      x = n.end(b);
    } catch {
      return L(0);
    }
    L(Math.ceil(x / d * 100));
  }
  function re() {
    W(), i?.();
  }
  function ie(o) {
    const n = parseFloat(o.target.value), d = u?.current;
    d.muted = !1, R(n), d.volume = n, D(n, o.target);
  }
  function D(o, n) {
    const d = o * 100, l = "#fff", b = "rgba(255, 255, 255, 0.3)";
    n.style.background = `linear-gradient(to right, ${l} 0%,
      ${l} ${d}%, ${b} ${d}%, ${b} 100%)`;
  }
  function le() {
    N(T);
    const o = u?.current;
    o.muted = !o.muted, R(o.muted ? 0 : Z), D(
      o.muted ? 0 : Z,
      z?.current
    );
  }
  function ae() {
    const o = H?.current;
    document.fullscreenElement ? document.exitFullscreen() : o.requestFullscreen();
  }
  function de() {
    _(!0);
    const o = u?.current, n = setInterval(function() {
      $(o.currentTime);
    }, 30);
    S(n), j?.();
  }
  function se() {
    _(!1), clearInterval(P), S(-1), F?.();
  }
  function ce() {
    const o = Math.floor(B / 60);
    let n = Math.floor(B % 60).toString();
    return parseInt(n) < 10 && (n = `0${n}`), `${o}:${n}`;
  }
  function ue() {
    const n = u?.current?.duration ?? 0, d = Math.floor(n / 60);
    let l = Math.floor(n % 60).toString();
    return parseInt(l) < 10 && (l = `0${l}`), `${d}:${l}`;
  }
  function he(o) {
    const n = u?.current, d = A?.current, l = d.offsetWidth, x = (o.clientX - d.getBoundingClientRect().left) / l * n.duration;
    n.currentTime = x, $(x);
  }
  function me(o) {
    const n = u?.current, d = 1;
    if (o.key === "ArrowRight") {
      const l = Math.min(
        n.currentTime + d,
        n.duration
      );
      n.currentTime = l, $(l);
    } else if (o.key === "ArrowLeft") {
      const l = Math.max(n.currentTime - d, 0);
      n.currentTime = l, $(l);
    } else
      (o.key === " " || o.key === "Enter") && M();
  }
  function ve(o) {
    if (V) {
      const n = u?.current;
      C ? n.textTracks[0].mode = "hidden" : n.textTracks[0].mode = "showing", q(!C);
    }
  }
  return fe(() => () => {
    P >= 0 && (clearInterval(P), S(-1));
  }, []), /* @__PURE__ */ s(_e, { ref: H, ...X, children: [
    /* @__PURE__ */ t(
      Be,
      {
        src: e || void 0,
        ref: u,
        onTimeUpdate: re,
        onEnded: te,
        onPlay: de,
        onClick: M,
        onPause: se,
        onLoadedMetadata: oe,
        onProgress: ne,
        controls: !1,
        loop: h,
        autoPlay: r,
        role: "video",
        children: v
      }
    ),
    /* @__PURE__ */ s(Te, { children: [
      /* @__PURE__ */ s(
        Ee,
        {
          onClick: he,
          onKeyDown: me,
          ref: A,
          tabIndex: 0,
          children: [
            /* @__PURE__ */ t(
              "div",
              {
                style: {
                  width: `${B / u?.current?.duration * 100}%`
                }
              }
            ),
            /* @__PURE__ */ t(
              "div",
              {
                style: {
                  width: `${J}%`
                }
              }
            )
          ]
        }
      ),
      /* @__PURE__ */ s(Ve, { children: [
        /* @__PURE__ */ s(I, { children: [
          /* @__PURE__ */ t(w, { onClick: M, children: E ? /* @__PURE__ */ t(pe, {}) : /* @__PURE__ */ t(ge, {}) }),
          /* @__PURE__ */ s(Ze, { children: [
            /* @__PURE__ */ t(
              w,
              {
                onClick: le,
                style: { marginRight: "10px" },
                children: T == 0 ? /* @__PURE__ */ t($e, {}) : /* @__PURE__ */ t(Se, {})
              }
            ),
            /* @__PURE__ */ t(
              Re,
              {
                type: "range",
                min: "0",
                max: "1",
                step: "0.01",
                value: T,
                onChange: ie,
                ref: z
              }
            )
          ] }),
          /* @__PURE__ */ s(Le, { children: [
            /* @__PURE__ */ t("div", { style: { minWidth: "30px" }, children: ce() }),
            /* @__PURE__ */ t("div", { style: { marginRight: c["1x"] }, children: "/" }),
            /* @__PURE__ */ t("div", { style: { minWidth: "30px" }, children: Y })
          ] })
        ] }),
        /* @__PURE__ */ s(I, { children: [
          /* @__PURE__ */ t(
            Me,
            {
              disabled: !V,
              onClick: ve,
              $showSubtitles: C,
              children: /* @__PURE__ */ t(
                ke,
                {
                  style: {
                    width: "26px",
                    height: c["5x"]
                  }
                }
              )
            }
          ),
          /* @__PURE__ */ t(w, { disabled: !0, children: /* @__PURE__ */ t(Pe, {}) }),
          /* @__PURE__ */ t(
            w,
            {
              onClick: ae,
              style: { marginRight: 0 },
              children: /* @__PURE__ */ t(Ce, {})
            }
          )
        ] })
      ] })
    ] })
  ] });
}
export {
  Fe as VideoPlayer
};
